import cx from "classnames"
import PropTypes from "prop-types"
import Image from "components/ui/Image"

function SplitContainer({
  className,
  children,
  image,
  imageSize = "regular",
  imageClassName,
  reversed,
}) {
  return (
    <div className={cx(className, "relative isolate")}>
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div
          className={cx("lg:w-1/2", {
            "2xl:w-[55%]": imageSize === "large" || imageSize === "huge",
            "lg:ml-auto": !!reversed,
          })}
        >
          {children}
        </div>
        {image && (
          <div
            className={cx(
              "-z-1 lg:absolute lg:top-1/2 lg:-translate-y-1/2",
              {
                "lg:right-0": !reversed,
                "lg:left-0": !!reversed,
                "lg:max-w-[45%]": imageSize === "regular",
                "lg:-translate-x-[7.5%]": imageSize === "regular" && !reversed,
                "lg:translate-x-[5%]": imageSize === "regular" && !!reversed,
                "lg:max-w-[60%]": imageSize === "large",
                "lg:max-w-[100%]": imageSize === "huge",
              },
              imageClassName
            )}
          >
            <Image className="h-full w-full" src={image} />
          </div>
        )}
      </div>
    </div>
  )
}

SplitContainer.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
  /** Text content */
  children: PropTypes.node,
  /** Background image */
  image: PropTypes.shape({}),
  /** Background image size */
  imageSize: PropTypes.oneOf(["regular", "large", "huge"]),
  /** Addicional image classNames */
  imageClassName: PropTypes.string,
  /** If true, displays image before text */
  reversed: PropTypes.bool,
}

export default SplitContainer
